import clsx from 'clsx';
import KioskLoadingIcon from '@/components/icons/KioskLoadingIcon';
import styles from './styles.module.scss';

type Props = {
    loading?: boolean;
};
export const ContentLoading = ({ loading = false }: Props) => {
    if (!loading) {
        return null;
    }

    return (
        <div className={clsx(styles['content-loading'], { [styles['content-loading--show']]: loading })}>
            <div className={styles['content-loading__logo']}>
                <KioskLoadingIcon className={styles['content-loading__icon']} />
            </div>
        </div>
    );
};
